import Http from '@helpers/Http';
import React, { useEffect, useState } from 'react';
import './index.module.less';
import { Api } from '@apis/client';
import { TNotificationGroup } from '@apis/notification/getNotificationGroup';
import NavBar from '@components/NavBar';
import { getOnlyDateExceptToday } from '@helpers/DateTime/timeUtils';
import BrowserHistory from '@helpers/BrowserHistory';
import userStore from '@stores/user';
import { rem } from '@helpers/Constants';
import EmptyView from '@views/sections/EmptyView';

const NotificationGroupList = () => {

  const [groupList, setNotificationGroupList] = useState<TNotificationGroup[]>(null);

  useEffect(() => {

    const fetchGroupStatisticsInfo = async (groupId: string) => {
      const result = await Http.post(Api.GetNotificationGroupStatistics, {
        groupUid: groupId,
        userUid: userStore.userInfo.uid
      });
      return result;
    }

    const fetchGroupList = async () => {
      const groupListResult = await Http.post(Api.GetNotificationGroup, {
        page: 1,
        pageSize: 20
      });

      const groupList = groupListResult?.data.result;
      if (groupList && groupList.length > 0) {
        for (let index = 0; index < groupList.length; index++) {
          const groupItem = groupList[index];
          const statisticsInfo = await fetchGroupStatisticsInfo(groupItem.uid);
          if (statisticsInfo?.data) {
            groupItem.tip = statisticsInfo.data.tip;
            groupItem.unReadCount = statisticsInfo.data.unReadCount;
            groupItem.lastMessage = statisticsInfo.data.message;
            groupItem.lastMessageTime = statisticsInfo.data.lastMessageTime;
          }
        }
      }

      setNotificationGroupList(groupList || []);
    }

    fetchGroupList();
  }, []);


  const groups = groupList?.map((item: TNotificationGroup) => {

    if (!item.lastMessage) {
      return;
    }

    const lastMessageTime = getOnlyDateExceptToday(item.lastMessageTime);
    let unReadCountText;
    if (item.unReadCount && item.unReadCount > 0) {
      unReadCountText = item.unReadCount > 99 ? '99+' : `${item.unReadCount}`
    }
    return (
      <div key={item.name} styleName='item-container' onClick={() => {
        BrowserHistory.push(`${PUBLIC_URL}/notificationList?groupUid=${item.uid}&groupName=${item.name}&tplType=${item.type}`);
      }}>
        <img styleName='icon' src={item.icon} alt='' />
        <div styleName='info-wrapper'>
          <div styleName='line-1'>
            <div styleName='title'>{item.name}</div>
            {lastMessageTime && <div styleName='time'>{lastMessageTime}</div>}
          </div>
          <div styleName='line-2'>
            <div styleName='tip-wrapper'>
              <div styleName='tip'>{item.tip || ''}</div>
              <div styleName='message'>{item.lastMessage || '暂无消息'}</div>
            </div>
            {unReadCountText &&
              <div styleName='unread' style={item.unReadCount > 99 ? { width: 0.4 * rem } : {}}>
                <div styleName={item.unReadCount > 99 ? 'text scale' : 'text'}>{unReadCountText}</div>
              </div>}
          </div>
        </div>
      </div>
    );
  }).filter((item) => { return item !== undefined});

  const hasData = groups && groups.length > 0;

  return (
    <div styleName={'container'} style={{ height: document.body.clientHeight }}>
      <NavBar title={'消息通知'} />
      {
        hasData &&
        <div styleName='group-wrapper'>
          <div styleName='group'>{groups}</div>
        </div>
      }
      { groups?.length === 0 && <EmptyView /> }
    </div>);
}

export default NotificationGroupList;